<template>
  <b-table
    class="is-middle"
    v-sortable="sortableOptions"
    :data="feeds.data"
    :loading="feeds.loading"
  >
    <template slot-scope="props">
      <b-table-column custom-key="move">
        <button type="button" class="button is-white drag-button" :feed-id="props.row.id">
          <b-icon icon="cursor-move" size="is-small"></b-icon>
        </button>
      </b-table-column>

      <b-table-column label="Feed">
        <div class="media">
          <div class="media-left">
            <img :src="props.row.background" width="50"/>
          </div>

          <div class="media-content">

            <router-link
              :to="`/feeds/${props.row.id}/edit`"
              class="has-text-dark"
              size="is-large"
            > {{ props.row.title }}
            </router-link
            >
            <br/>
            <small>
              # {{ props.row.id }}

              <span class="tag is-primary ml-1" v-if="props.row.pinned">pin
                        <button type="button" class="delete is-small" @click="unPin(props.row.id)">
                      </button>
                      </span>
              <span class="button is-outlined tag is-primary ml-1" @click="addPin(props.row.id)"
                    v-if="!props.row.pinned">
                          pin
                      </span>
            </small>
          </div>
        </div>
      </b-table-column>

      <b-table-column custom-key="actions">
        <div class="is-pulled-right">
          <button type="button" class="button is-white" @click="removeData(props.row)">
            <b-icon icon="close" size="is-small"></b-icon>
          </button>
        </div>
      </b-table-column>
    </template>
  </b-table>
</template>

<script>

export default {
  data() {
    return {
      sortableOptions: {
        chosenClass: "is-selected",
        handle: ".drag-button",

        onChange: event => {
          this.newId = event.newIndex;
        },
        onUpdate: event => {
          let feedId = event.item
            .getElementsByClassName("drag-button")[0]
            .getAttribute("feed-id");

          let endpoint = `/admin/api/collections/${this.$route.params.id}/feeds/${feedId}`;

          this.$http.put(endpoint, {order: this.newId});
        }
      },

      feeds: new window.RemoteCollection(() => {
        return `/admin/api/collections/${this.$route.params.id}/feeds`;
      }).load(),
    };
  },

  methods: {
    reload() {
      this.feeds.load();
    },

    removeData(data) {
      this.$http
        .delete(
          "/admin/api/collections/" +
          this.$route.params.id +
          "/feeds/" +
          data.id
        ).then(() => {
        this.feeds.load();
      });
    },

    addPin(data) {
      this.$http
        .post(`/admin/api/collections/${this.$route.params.id}/pin/${data}/feeds`
        ).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });

        this.feeds.load();
      });
    },

    unPin(data) {
      this.$http
        .post(`/admin/api/collections/${this.$route.params.id}/unpin/${data}/feeds`
        ).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });

        this.feeds.load();
      });
    },
  }
};
</script>
